import { map } from 'lodash';

export const SLIDE_IDENTIFIER_HEADER_OPTIONS = ['Slide ID', 'File Name'];
export const MANDATORY_HEADERS = ['Case ID', 'Stain Type', 'Cancer Type'];
export const METASTASIS_HEADER = 'Metastasis (Y/N)';
export const POSITIVE_CONTROL_HEADER = 'Positive Control on Slide (Y/N)';
export const NEGATIVE_CONTROL_HEADER = 'Negative Control on Slide (Y/N)';

export const NEW_CASE_HEADER = 'New case (leave blank to match existing case)';

export const MANIFEST_HEADERS = [
  NEW_CASE_HEADER,
  ...MANDATORY_HEADERS,
  ...SLIDE_IDENTIFIER_HEADER_OPTIONS,
  'Biopsy Site',
  'Cancer Subtype',
  'Biopsy Type',
  'Preservation Method',
  'Procedure Type',
  METASTASIS_HEADER,
  POSITIVE_CONTROL_HEADER,
  NEGATIVE_CONTROL_HEADER,
];
export const LOWER_CASE_SLIDE_IDENTIFIER_HEADER_OPTIONS = map(SLIDE_IDENTIFIER_HEADER_OPTIONS, (header) =>
  header.toLowerCase()
);
export const LOWER_CASE_MANDATORY_HEADERS = map(MANDATORY_HEADERS, (header) => header.toLowerCase());
export const LOWER_CASE_MANIFEST_HEADERS = map(MANIFEST_HEADERS, (header) => header.toLowerCase());

export const BOOLEAN_OPTIONS = ['y', 'n', 'yes', 'no'];
